import React, { useEffect, useRef, useState } from 'react';
import { bulletinLogoManager } from 'Utils/bulletinLogoManager';
import PropTypes from 'prop-types';

const SafeImage = ({ src, fallback, alt, ...rest }) => {
  const [currentSrc, setCurrentSrc] = useState(fallback);
  const controllerRef = useRef(null);
  const imgRef = useRef(null);

  // src değişince fallback göster
  useEffect(() => {
    setCurrentSrc(fallback);
  }, [src, fallback]);

  useEffect(() => {
    if (!src) return;
    if (typeof window === 'undefined') return;
    if (!window.IntersectionObserver) return;

    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          controllerRef.current?.abort();
          return;
        }

        controllerRef.current = new AbortController();

        bulletinLogoManager(src, controllerRef.current.signal)
          .then(objectUrl => {
            setCurrentSrc(objectUrl);
          })
          .catch(() => {
            setCurrentSrc(fallback);
          });

        observer.unobserve(entry.target); // 🔥 sadece bu elementi bırak
      },
      { rootMargin: '150px' }
    );

    const node = imgRef.current;
    if (node) observer.observe(node);

    return () => {
      if (node) observer.unobserve(node);
      observer.disconnect();
      controllerRef.current?.abort();
    };
  }, [src, fallback]);


  return (
    <img
      ref={ imgRef }
      src={ currentSrc }
      alt={ alt }
      loading="lazy"
      decoding="async"
      { ...rest }
    />
  );
};

SafeImage.propTypes = {
  src: PropTypes.string,
  fallback: PropTypes.string,
  alt: PropTypes.string,
};

SafeImage.defaultProps = {
  src: '',
  alt: '',
};

export default SafeImage;
